// import React, { useState, useEffect, useContext } from "react";
// import AdminContext from "../../StateContext/Application";
// import { apiurl } from "../../../../path";
// import { Link, useNavigate } from "react-router-dom";
// import "./rejectpanel.css";
// import {
//   Back32,
//   Cancel32,
//   ProposalCreation32,
//   submit,
// } from "../../../../public/LoginImages/importimages";
// import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
// const ProgressReportInwardsList = () => {
//   const { language, toggleLanguage, t } = useLanguage();
//   const context = useContext(AdminContext);
//   const {
//     GetBudgetHeadInfo,
//     ProgressReportApprovalOperation,
//     CreateToken,
//     GetProgressReportInwardList,
//   } = context;
//   const nav = useNavigate();
//   const [technicalInwards, setTechnicalInwards] = useState([]);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [showSpecific, setShowSpecific] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [rejectPanelhide, setRejectpanelhide] = useState(1);
//   const [remark, setRemark] = useState("");
//   const [selectedBills, setSelectedBills] = useState([]);
//   const [filteredBills, setFilteredBills] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const billsPerPage = 10;
//   const [searchTerm, setSearchTerm] = useState("");

//   const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
//   const indexOfLastBill = currentPage * billsPerPage;
//   const indexOfFirstBill = indexOfLastBill - billsPerPage;
//   // const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
//   const sortedBills = Array.isArray(filteredBills)
//     ? filteredBills
//         .slice() // ✅ prevent state mutation
//         .sort((a, b) => new Date(b.Date) - new Date(a.Date))
//     : [];
//   const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
//   const [hide, sethide] = useState(true);
//   const [Etoken, SetEtoken] = useState(false);
//   const [GenerateToken, SetGenerateToken] = useState(true);
//   const [GenerateRejectToken, SetGenerateRejectToken] = useState(true);

//   async function GenerateTokenFor(e) {
//     e.preventDefault();
//     let data = await CreateToken("Proposal Approval");
//     document.getElementById("tokencopys").innerText = data;
//     SetEtoken(data);
//     sethide(false);
//   }
//   const headerStyle = {
//     padding: "12px 16px",
//     whiteSpace: "nowrap",
//     borderRight: "1px solid #e0e0e0",
//     textTransform: "capitalize",
//   };
//   const headerStyle2 = {
//     padding: "12px 16px",
//     whiteSpace: "nowrap",
//     borderRight: "1px solid #e0e0e0",
//     textTransform: "capitalize",
//   };

//   let inwardList = [];
//   if (technicalInwards.length > 0) {
//     inwardList = technicalInwards;
//   }
//   useEffect(() => {
//     const lowerSearchTerm = searchTerm.toLowerCase();
//     const filtered = technicalInwards.filter((bill) =>
//       Object.values(bill).some((val) =>
//         (val || "").toString().toLowerCase().includes(lowerSearchTerm)
//       )
//     );
//     setFilteredBills(filtered);
//     setCurrentPage(1);
//   }, [searchTerm, technicalInwards]);

//   // const handleCheckboxChange = (techincaluid,physicalwork) => {
//   //     const key = `${techincaluid}-${physicalwork}`
//   //     setSelectedBills((prevSelected) =>
//   //         prevSelected.includes(key)
//   //             ? prevSelected.filter((billId) => billId !== key)
//   //             : [...prevSelected, key]
//   //     );
//   // };

//   const handleCheckboxChange = (id) => {
//     setSelectedBills((prev) =>
//       prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
//     );
//   };

//   // console.log("Slected id form table :: ", selectedBills);
//   // console.log("Filtered data id form table :: ", filteredBills);

//   const handleSelectAll = (e) => {
//     const checked = e.target.checked;
//     const currentPageIds = currentBills.map((b) => b.ID);

//     setSelectedBills((prev) => {
//       if (checked) {
//         // ✅ add current page IDs without duplicates
//         return Array.from(new Set([...prev, ...currentPageIds]));
//       } else {
//         // ✅ remove only current page IDs
//         return prev.filter((id) => !currentPageIds.includes(id));
//       }
//     });
//   };

//   //want to send MHUID and physicalvalue
//   const selectedRows = filteredBills.filter((row) =>
//     selectedBills.includes(row.ID)
//   );
//   const findMHUID = selectedRows.map((r) => r.TechnicalUID);
//   const physical = selectedRows.map((r) => r.physicalValue);
//   // console.log("ffasd", selectedRows, findMHUID, physical);

//   // const approveorrejectSelected = async (condition) => {
//   //     if (selectedBills.length === 0) {
//   //         alert('No Proposal selected for approval!');
//   //         return;
//   //     }
//   //     console.log(selectedBills);
//   //     setLoading(true); // Start loader

//   //     try {
//   //         let response = await ProgressReportApprovalOperation(selectedBills, condition, remark, Etoken); // Call backend function
//   //         if (response.message) {
//   //             alert(response.message);
//   //             window.location.reload()
//   //             setRemark("");
//   //             setRejectpanelhide(false)
//   //             getTechnicalInwardsList(); // Refresh the list after approval
//   //         }
//   //         if (response.error) {
//   //             alert(response.error)
//   //             window.location.reload()
//   //             getTechnicalInwardsList(); // Refresh the list after approval
//   //         }
//   //     } catch (error) {
//   //         console.error('Error approving Proposal:', error);
//   //         alert('An error occurred while approving bills.');
//   //     }
//   //     setLoading(false); // Stop loader
//   // };

//   const approveorrejectSelected = async (condition) => {
//     if (selectedBills.length === 0) {
//       alert("No Proposal selected for approval!");
//       return;
//     }
//     // console.log("hfdfsfs", selectedBills);
//     setLoading(true); // Start loader

//     // try {
//     //   let response = await ProgressReportApprovalOperation(
//     //     selectedBills,
//     //     condition,
//     //     remark,
//     //     findMHUID,
//     //     physical,
//     //     Etoken
//     //   ); // Call backend function
//     //   if (response.message) {
//     //     alert(response.message);

//     //     setSelectedBills([]); // ✅ RESET SELECTION
//     //     setRejectpanelhide(1);
//     //     setRemark("");

//     //     getTechnicalInwardsList(); // refresh data
//     //   }
//     //   if (response.error) {
//     //     alert(response.error);
//     //     window.location.reload();
//     //     getTechnicalInwardsList(); // Refresh the list after approval
//     //   }
//     // } catch (error) {
//     //   console.error("Error approving Proposal:", error);
//     //   alert("An error occurred while approving bills.");
//     // }
//       try {

// // console.log("type",condition);

// console.log("selectedBills",selectedBills);

// const payload = selectedBills.map((bill, index) => ({
//   id: bill,
//   MHUID: findMHUID[index],
//   physicalValue: physical[index],
//   remark,
//   type: condition
// }));
// console.log("type",selectedBills[0].condition);

// console.log("payload",payload)
// let response = await ProgressReportApprovalOperation(
//   payload,
//   Etoken
// );

//     //   let response = await ProgressReportApprovalOperation(
//     //     selectedBills,
//     //     condition,
//     //     remark,
//     //     findMHUID,
//     //     physical,
//     //     Etoken
//     //   ); // Call backend function
//       if (response.message) {
//       alert(response.message);
//               window.location.reload()
//               setRemark("");
//               setRejectpanelhide(false)
//               getTechnicalInwardsList();
//       }
//       if (response.error) {
//         alert(response.error);
//         window.location.reload();
//         getTechnicalInwardsList(); // Refresh the list after approval
//       }
//     } catch (error) {
//       console.error("Error approving Proposal:", error);
//       alert("An error occurred while approving bills.");
//     }
//     setLoading(false); // Stop loader
//   };

//   const [selectedUploadId, setSelectedUploadID] = useState();
//   const [FetchedImages, setFetchedImages] = useState([]);

//   const fetchSpecficUploadPhoto = async (headCode, workName, physicalWork) => {
//     console.log("here-photo", headCode, workName, physicalWork);
//     let HeadCode = { headCode: headCode, workName: workName };
//     try {
//       let res = await GetBudgetHeadInfo(
//         HeadCode,
//         "GetSpecificUploadImagesfromProgressTable"
//       );
//       const filteredImages = res.filter(
//         (img) => img.physicalValue === physicalWork
//       );
//       console.log("filteredImages", filteredImages);
//       setFetchedImages(filteredImages);
//       setSelectedUploadID(workName);
//       setShowSpecific(1);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const rejectSendbackbeforecheckup = (id) => {
//     if (selectedBills.length > 0) {
//       setRejectpanelhide(id);
//     } else {
//       alert("No Bill Selected !!!");
//     }
//   };

//   const navigatetoMap = async (mhuid) => {
//     setLoading(true);
//     try {
//       let res = await GetBudgetHeadInfo(
//         mhuid,
//         "GetSpecificTechincalSanctionInfoBYSanctionNo"
//       );

//       if (res && res.length <= 0) {
//         alert("No Location Found");
//         return;
//       }

//       let technicaldata = res[0];

//       if (technicaldata.MultipleGramPanchayat === "Yes") {
//         const fetchurl = `https://grammanchitra.gov.in/gpassetsCollectionMH?dpcode=${technicaldata.DPCode}&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3MTcxNDM5OTksImV4cCI6MTcxNzE1MTE5OSwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NzAzNC8iLCJhdWQiOiJodHRwczovL2xvY2FsaG9zdDo3MDM0LyJ9.Yb3a_9eB5DEC9OeGfO7GoUgqxnhfRDF6fZMHdPhW3hg&activityCode=${technicaldata.Proposal_UID}&forRddAssetCode=true&projectId=${technicaldata.Proposal_UID}&rddassetCode=${technicaldata.GR_UID}`;
//         window.open(fetchurl, "_blank");
//       } else if (technicaldata.MultipleGramPanchayat === "No") {
//         const fetchurl = `https://grammanchitra.gov.in/gpassetsCollectionMH?gpcode=${technicaldata.GPCode}&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3MTcxNDM5OTksImV4cCI6MTcxNzE1MTE5OSwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NzAzNC8iLCJhdWQiOiJodHRwczovL2xvY2FsaG9zdDo3MDM0LyJ9.Yb3a_9eB5DEC9OeGfO7GoUgqxnhfRDF6fZMHdPhW3hg&activityCode=${technicaldata.Proposal_UID}&forRddAssetCode=true&projectId=${technicaldata.Proposal_UID}&rddassetCode=${technicaldata.GR_UID}`;
//         window.open(fetchurl, "_blank");
//       }
//     } catch (err) {
//       setLoading(false);
//       alert("Interval Server Error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const parseUploads = (upload) => {
//     try {
//       if (Array.isArray(upload)) return upload;
//       return JSON.parse(upload || "[]");
//     } catch {
//       return [];
//     }
//   };

// const getTechnicalInwardsList = async () => {
//       let data = await GetProgressReportInwardList("All", "All");
//       const sortedData = data.sort((a, b) => new Date(a.Date) - new Date(b.Date));
//       console.log("data-----------", data);
//       setTechnicalInwards(data);
//       setFilteredBills(data);
//     };

//     useEffect(() => {
//       getTechnicalInwardsList();
//     }, []);
//   return (
//     <>
//       {showSpecific === 0 && (
//         <div>
//           <div
//             sclass="col-12"
//             style={{
//               backgroundColor: "#EFF3F8",
//               height: "89vh",
//               overflowX: "hidden",
//               overflowY: "scroll",
//             }}
//           >
//             <div className="col-11 m-auto">
//               <div className="col-12">
//                 <div
//                   className="col-12 px-4 mb-4 mt-3"
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <h5 className="my-auto fw-bold">
//                     <img
//                       src="/GR-Approval64.png"
//                       alt="Technical Approval"
//                       style={{ width: "24px", height: "24px" }}
//                       className="my-auto me-1"
//                     />
//                     <span className="my-auto">
//                       {t("Progress Report Inward List")}
//                     </span>
//                   </h5>
//                   <div
//                     style={{
//                       position: "relative",
//                       width: "250px",
//                       marginRight: "10px",
//                     }}
//                   >
//                     <img
//                       src="/Search32.png"
//                       alt="Search Icon"
//                       style={{
//                         position: "absolute",
//                         top: "50%",
//                         left: "10px",
//                         transform: "translateY(-50%)",
//                         width: "16px",
//                         height: "16px",
//                         opacity: 0.6,
//                       }}
//                     />
//                     <input
//                       type="text"
//                       placeholder={t("Search")}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                       value={searchTerm}
//                       style={{
//                         width: "100%",
//                         padding: "8px 12px 8px 32px", // left padding makes space for icon
//                         border: "1px solid #ccc",
//                         borderRadius: "8px",
//                         backgroundColor: "#f1f6fc",
//                         fontSize: "14px",
//                         color: "#333",
//                         boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                         outline: "none",
//                       }}
//                     />
//                   </div>
//                 </div>
//                 <div className="col-12 pb-5">
//                   <div
//                     lassName="col-12 mb-3"
//                     style={{
//                       backgroundColor: "white",
//                       padding: "30px 40px ",
//                       boxShadow: "0px 0px 5px 1px #E4E8EC",
//                       borderRadius: "20px",
//                       width: "fit-content",
//                     }}
//                   >
//                     <div
//                       className="col-12 tableDesign"
//                       style={{
//                         // background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )',
//                         background: "#2C78DB",
//                         display: "flex",
//                         width: "70vw",
//                         overflowX: "auto",
//                         border: "1px solid #3b409e",
//                       }}
//                     >
//                       <table
//                         className="m-0 p-0"
//                         style={{ width: "100%", borderCollapse: "collapse" }}
//                       >
//                         <thead>
//                           <tr
//                             style={{
//                               color: "white",
//                               border: "none",
//                               height: "3rem",
//                               fontSize: "18px",
//                             }}
//                           >
//                             <th style={headerStyle}>
//                               <input
//                                 type="checkbox"
//                                 onChange={handleSelectAll}
//                                 checked={
//                                   currentBills.length > 0 &&
//                                   currentBills.every((bill) =>
//                                     selectedBills.includes(bill.ID)
//                                   )
//                                 }
//                                 className="my-auto"
//                                 style={{ height: "1rem", width: "1rem" }}
//                               />
//                             </th>
//                             <th style={headerStyle}>{t("Sr.No.")}</th>
//                             <th
//                               style={{
//                                 padding: "14px 20px",
//                                 minWidth: "180px",
//                               }}
//                             >
//                               {t("Head Code")}
//                             </th>
//                             <th
//                               style={{
//                                 padding: "14px 20px",
//                                 minWidth: "180px",
//                               }}
//                             >
//                               {t("Proposal Year")}
//                             </th>
//                             <th
//                               style={{
//                                 padding: "14px 20px",
//                                 minWidth: "180px",
//                               }}
//                             >
//                               {t("Word Order Name")}
//                             </th>
//                             <th
//                               style={{
//                                 padding: "14px 20px",
//                                 minWidth: "180px",
//                               }}
//                             >
//                               {t("MHUID Number")}
//                             </th>
//                             <th
//                               style={{
//                                 padding: "14px 20px",
//                                 minWidth: "180px",
//                               }}
//                             >
//                               {t("Gram Panchayat")}
//                             </th>
//                             <th
//                               style={{
//                                 padding: "14px 20px",
//                                 minWidth: "180px",
//                               }}
//                             >
//                               {t("District")}
//                             </th>
//                             <th
//                               style={{
//                                 padding: "14px 20px",
//                                 minWidth: "180px",
//                               }}
//                             >
//                               {t("Uploaded Date")}
//                             </th>
//                             <th
//                               style={{
//                                 padding: "14px 20px",
//                                 minWidth: "180px",
//                               }}
//                             >
//                               {t("Physical Progress (%)")}
//                             </th>
//                             <th
//                               style={{
//                                 padding: "14px 20px",
//                                 minWidth: "180px",
//                               }}
//                             >
//                               {t("Remark")}
//                             </th>
//                             <th
//                               style={{
//                                 padding: "14px 20px",
//                                 minWidth: "180px",
//                               }}
//                             >
//                               {t("Action")}
//                             </th>
//                             <th
//                               style={{
//                                 padding: "14px 20px",
//                                 minWidth: "180px",
//                               }}
//                             >
//                               {t("View Map")}
//                             </th>
//                             {/* <th style={{ width: "14%" }}>Proposal amount (In CR)</th> */}
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {currentBills?.length === 0 ? (
//                             <tr>
//                               <td
//                                 colSpan="12"
//                                 style={{
//                                   textAlign: "center",
//                                   padding: "20px",
//                                   backgroundColor: "#f9f9f9",
//                                 }}
//                               >
//                                 {t("No data available")}
//                               </td>
//                             </tr>
//                           ) : (
//                             currentBills?.map((technicalInwards, index) => {
//                               const bgColor =
//                                 index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                               // console.log(
//                               //   "technicalInwards.Head_Code",
//                               //   technicalInwards
//                               // );
//                               return (
//                                 <tr
//                                   className="px-3"
//                                   key={index}
//                                   style={{
//                                     backgroundColor: bgColor,
//                                     fontSize: "18px",
//                                     fontWeight: "400",
//                                   }}
//                                 >
//                                   <td style={{ textAlign: "center" }}>
//                                     {/* <input
//                                                                             type="checkbox"
//                                                                             className='my-auto'
//                                                                             style={{ height: '1rem', width: '1rem' }}
//                                                                             checked={selectedBills.includes(`${technicalInwards.TechnicalUID}-${technicalInwards.physicalValue}`)}
//                                                                             onChange={() => handleCheckboxChange(technicalInwards.TechnicalUID,technicalInwards.physicalValue)}
//                                                                         /> */}
//                                     <input
//                                       type="checkbox"
//                                       className="my-auto"
//                                       style={{ height: "1rem", width: "1rem" }}
//                                       checked={selectedBills.includes(
//                                         technicalInwards.ID
//                                       )}
//                                       onChange={() =>
//                                         handleCheckboxChange(
//                                           technicalInwards.ID
//                                         )
//                                       }
//                                     />
//                                   </td>
//                                   <td style={{ padding: "8px 8px" }}>
//                                     {indexOfFirstBill + index + 1}
//                                   </td>
//                                   <td style={{ padding: "8px 8px" }}>
//                                     {technicalInwards.Head_Code}
//                                   </td>
//                                   <td style={{ padding: "8px 8px" }}>
//                                     {technicalInwards.ProposalYear}
//                                   </td>
//                                   <td style={{ padding: "8px 8px" }}>
//                                     {technicalInwards.WorkOrderNo}
//                                   </td>
//                                   <td style={{ padding: "8px 8px" }}>
//                                     {technicalInwards.TechnicalUID}
//                                   </td>
//                                   <td style={{ padding: "8px 8px" }}>
//                                     {technicalInwards.gram_panchayat}
//                                   </td>
//                                   <td style={{ padding: "8px 8px" }}>
//                                     {technicalInwards.District}
//                                   </td>
//                                   <td style={{ padding: "8px 8px" }}>
//                                     {new Date(
//                                       technicalInwards.Date
//                                     ).toLocaleString()}
//                                   </td>
//                                   <td style={{ padding: "8px 8px" }}>
//                                     {technicalInwards.physicalValue}
//                                   </td>
//                                   <td style={{ padding: "8px 8px" }}>
//                                     {technicalInwards.Remark}
//                                   </td>
//                                   {/* <td className='py-2'>{technicalInwards.Proposal_fileNumber}</td> */}
//                                   {/* <td className='py-2'>{
//                                                         technicalInwards.Proposal_copy ?
//                                                             (<a href={`${apiurl}/ProposalFile/${technicalInwards.Proposal_copy}`} target='_blank'>{technicalInwards.Proposal_copy}</a>)
//                                                             :
//                                                             (<p className='text-danger my-auto fw-bold'>No Copy</p>)
//                                                     }
//                                                     </td>
//                                                     <td style={{ padding: '8px' }}>{
//                                                         technicalInwards.Additional_suppDoc ?
//                                                             (<a href={`${apiurl}/ProposalFile/${technicalInwards.Additional_suppDoc}`} target='_blank'>{technicalInwards.Additional_suppDoc}</a>)
//                                                             :
//                                                             (<p className='text-danger my-auto fw-bold'>No Copy</p>)
//                                                     }
//                                                     </td> */}
//                                   <td
//                                     style={{
//                                       padding: "8px 8px",
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     <button
//                                       className="btn btn-success px-3"
//                                       onClick={() =>
//                                         fetchSpecficUploadPhoto(
//                                           technicalInwards.Head_Code,
//                                           technicalInwards.WorkOrderNo,
//                                           technicalInwards.physicalValue
//                                         )
//                                       }
//                                       style={{
//                                         fontSize: "18px",
//                                         background:
//                                           "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                                         color: "white",
//                                         border: "none",
//                                         padding: "6px 12px",
//                                         borderRadius: "8px",
//                                         display: "inline-flex",
//                                         justifyContent: "center",
//                                         alignItems: "center",
//                                         gap: "4px",
//                                         whiteSpace: "nowrap",
//                                       }}
//                                     >
//                                       {t("View Photos")}
//                                     </button>
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "8px 8px",
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     <button
//                                       onClick={() =>
//                                         navigatetoMap(
//                                           technicalInwards.TechnicalUID
//                                         )
//                                       }
//                                       style={{
//                                         cursor: "pointer",
//                                         background:
//                                           "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                                         color: "white",
//                                         border: "none",
//                                         padding: "6px 10px",
//                                         borderRadius: "8px",
//                                         fontSize: "18px",
//                                         display: "inline-flex",
//                                         justifyContent: "center",
//                                         alignItems: "center",
//                                         gap: "4px",
//                                         whiteSpace: "nowrap",
//                                       }}
//                                     >
//                                       {t("Go to Map")}
//                                     </button>
//                                   </td>
//                                 </tr>
//                               );
//                             })
//                           )}
//                         </tbody>
//                       </table>
//                     </div>

//                     {/* Showing entries & Pagination */}
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         marginTop: "20px",
//                         padding: "0 12px",
//                       }}
//                     >
//                       {/* Left side - Showing entries */}
//                       <p style={{ margin: 0 }}>
//                         {t("Showing")}{" "}
//                         {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
//                         {t("to")}{" "}
//                         {Math.min(indexOfLastBill, filteredBills.length)}{" "}
//                         {t("of")} {technicalInwards?.length} {t("entries")}
//                       </p>

//                       {/* Right side - Pagination */}
//                       <div>
//                         <button
//                           onClick={() => setCurrentPage(1)}
//                           disabled={currentPage === 1}
//                           style={{
//                             backgroundColor: "white",
//                             color: "black",
//                             border: "1px solid lightgrey",
//                             cursor: "pointer",
//                             fontSize: "20px",
//                             width: "2rem",
//                           }}
//                         >
//                           &laquo;
//                         </button>

//                         <button
//                           onClick={() => setCurrentPage(currentPage - 1)}
//                           disabled={currentPage === 1}
//                           style={{
//                             backgroundColor: "white",
//                             color: "black",
//                             border: "1px solid lightgrey",
//                             cursor: "pointer",
//                             fontSize: "20px",
//                             borderLeft: "none",
//                             width: "2rem",
//                           }}
//                         >
//                           &lt;
//                         </button>

//                         <button
//                           style={{
//                             background:
//                               "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
//                             color: "white",
//                             cursor: "pointer",
//                             fontSize: "20px",
//                             width: "2.4rem",
//                             border: "1px solid lightgrey",
//                             borderLeft: "none",
//                           }}
//                         >
//                           {currentPage}
//                         </button>

//                         <button
//                           onClick={() => setCurrentPage(currentPage + 1)}
//                           disabled={currentPage === totalPages}
//                           style={{
//                             backgroundColor: "white",
//                             color: "black",
//                             border: "1px solid lightgrey",
//                             cursor: "pointer",
//                             fontSize: "20px",
//                             borderLeft: "none",
//                             width: "2rem",
//                           }}
//                         >
//                           &gt;
//                         </button>

//                         <button
//                           onClick={() => setCurrentPage(totalPages)}
//                           disabled={currentPage === totalPages}
//                           style={{
//                             backgroundColor: "white",
//                             color: "black",
//                             border: "1px solid lightgrey",
//                             cursor: "pointer",
//                             fontSize: "20px",
//                             borderLeft: "none",
//                             width: "2rem",
//                           }}
//                         >
//                           &raquo;
//                         </button>
//                       </div>
//                     </div>
//                     {/* Approve / Reject buttons */}
//                     <div
//                       className="my-2"
//                       style={{
//                         display: "flex",
//                         justifyContent: "flex-start",
//                         alignItems: "center",
//                       }}
//                     >
//                       <button
//                         className="ms-0"
//                         onClick={() => approveorrejectSelected("Approved")}
//                         disabled={selectedBills.length <= 0 ? true : loading}
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "0.3rem",
//                           margin: "12px",
//                           padding: "8px 10px",
//                           fontWeight: "600",
//                           backgroundColor:
//                             selectedBills.length <= 0
//                               ? "rgba(141, 141, 141, 0.97)"
//                               : "#39B54A",
//                           color: "white",
//                           borderRadius: "8px",
//                           cursor:
//                             selectedBills.length <= 0
//                               ? "not-allowed"
//                               : loading
//                               ? "not-allowed"
//                               : "pointer",
//                         }}
//                       >
//                         <img
//                           src="/Approve-Selected32.png"
//                           style={{
//                             width: "1rem",
//                             height: "1rem",
//                             filter: "brightness(0) invert(1)",
//                           }}
//                         />
//                         {loading ? t("Processing...") : t("Approve Selected")}
//                       </button>

//                       <button
//                         onClick={() => rejectSendbackbeforecheckup(2)}
//                         disabled={selectedBills.length <= 0 ? true : loading}
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "0.3rem",
//                           margin: "12px",
//                           padding: "8px 10px",
//                           fontWeight: "600",
//                           background:
//                             selectedBills.length <= 0
//                               ? "rgba(141, 141, 141, 0.97)"
//                               : "#C1272D",
//                           color: "white",
//                           borderRadius: "8px",
//                           cursor:
//                             selectedBills.length <= 0
//                               ? "not-allowed"
//                               : loading
//                               ? "not-allowed"
//                               : "pointer",
//                         }}
//                       >
//                         <img
//                           src="/Reject-Selected32.png"
//                           style={{
//                             width: "1rem",
//                             height: "1rem",
//                             filter: "brightness(0) invert(1)",
//                           }}
//                         />{" "}
//                         {loading ? "Processing..." : t("Reject Selected")}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {rejectPanelhide === 2 && (
//             <div className="col-12 RejectPanelContainer">
//               <div className="Rejectpanel">
//                 <form action="">
//                   <div className="col-12 elements">
//                     <div className="row">
//                       <div className="col-3">
//                         <label className="fw-bold">
//                           {t("Remark")} <span className="text-danger">*</span>
//                         </label>
//                       </div>
//                       <div className="col-8">
//                         <textarea
//                           name=""
//                           id=""
//                           placeholder={t("Enter Remark")}
//                           onChange={(e) => setRemark(e.target.value)}
//                         ></textarea>
//                       </div>
//                     </div>
//                   </div>
//                 </form>
//                 <div className="col-12 ms-auto my-4">
//                   <div className="row">
//                     <div className="col-9 m-auto">
//                       <div
//                         className="col-12"
//                         style={{
//                           display: "flex",
//                           gap: "10px",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <button
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             gap: "4px",
//                             background:
//                               "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                             width: "5rem",
//                             height: "2rem",
//                             fontSize: "18px",
//                           }}
//                           onClick={() => approveorrejectSelected("Rejected")}
//                         >
//                           <img src={submit} style={{ width: "15px" }} />{" "}
//                           {t("Reject")}
//                         </button>
//                         <button
//                           type="button"
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             gap: "4px",
//                             backgroundColor: "#f1594c",
//                             width: "6rem",
//                             height: "2rem",
//                             fontSize: "16px",
//                           }}
//                           onClick={() => window.location.reload()}
//                         >
//                           {" "}
//                           <img src={Cancel32} style={{ width: "17px" }} />
//                           {t("Cancel")}
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* {
//                         rejectPanelhide === 3 &&

//                         <div className='col-12 RejectPanelContainer'>
//                             <div className="Rejectpanel">
//                                 <form action="">

//                                     <div className="col-12 elements">
//                                         <div className="row">
//                                             <div className="col-3">
//                                                 <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
//                                             </div>
//                                             <div className="col-8">
//                                                 <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
//                                                 </textarea>
//                                             </div>
//                                         </div>
//                                     </div>

//                                 </form>
//                                 <div className="col-12 ms-auto my-4">
//                                     <div className="row">

//                                         <div className="col-9 m-auto">
//                                             <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
//                                                 <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '8rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("SendBack")}><img src={submit} style={{ width: '15px' }} /> Send Back</button>
//                                                 <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     } */}

//           <div className="card">
//             <div
//               style={{
//                 position: "fixed",
//                 padding: "10rem",
//                 top: 0,
//                 left: 0,
//                 width: "100%",
//                 height: "100%",
//                 backgroundColor: "rgba(0, 0, 0, 0.5)",
//                 backdropFilter: "blur(5px)",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 zIndex: 1000,
//               }}
//               hidden={GenerateToken}
//             >
//               <div
//                 class="card-body"
//                 style={{ backgroundColor: "white", width: "50%" }}
//               >
//                 <h6>{t("Send Message")}</h6>
//                 <div class="card form-control" style={{ width: "100%" }}>
//                   <div class="card-body">
//                     <h5 class="card-title">{t("Generate Token")}</h5>
//                     <textarea
//                       class="form-control"
//                       id="tokencopys"
//                       value={Etoken}
//                     ></textarea>
//                     <button
//                       hidden={Etoken}
//                       className="btn btn-success mx-2"
//                       style={{
//                         backgroundColor: "rgb(10, 200, 150)",
//                         border: "none",
//                         borderRadius: "10px",
//                       }}
//                       onClick={GenerateTokenFor}
//                     >
//                       {t("Generate Token")}
//                     </button>
//                   </div>
//                 </div>
//                 <button
//                   onClick={() => approveorrejectSelected("Approved")}
//                   hidden={hide}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     margin: "12px",
//                     padding: "8px 15px",
//                     background:
//                       "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
//                     color: "white",
//                     borderRadius: "5px",
//                     cursor: loading ? "not-allowed" : "pointer",
//                   }}
//                 >
//                   <img
//                     style={{ width: "14px", filter: "brightness(0) invert(1)" }}
//                   />{" "}
//                   {loading ? "Processing..." : "Approve Selected"}
//                 </button>
//                 {/* <button className='btn btn-success mx-2 my-2' onClick={() => Approve(selectedType)} hidden={hide} >Approve</button> */}
//                 <button
//                   className="btn btn-danger"
//                   onClick={(x) => {
//                     SetGenerateToken(true);
//                     SetEtoken("");
//                   }}
//                 >
//                   close
//                 </button>
//               </div>
//             </div>
//           </div>

//           <div className="card">
//             <div
//               style={{
//                 position: "fixed",
//                 padding: "10rem",
//                 top: 0,
//                 left: 0,
//                 width: "100%",
//                 height: "100%",
//                 backgroundColor: "rgba(0, 0, 0, 0.5)",
//                 backdropFilter: "blur(5px)",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 zIndex: 1000,
//               }}
//               hidden={GenerateRejectToken}
//             >
//               <div class="card-body" style={{ backgroundColor: "white" }}>
//                 <h6>{t("Send Message")}</h6>
//                 <div class="card form-control" style={{ width: "100%" }}>
//                   <div class="card-body">
//                     <h5 class="card-title">{t("Generate Token")}</h5>
//                     <textarea
//                       class="form-control"
//                       id="tokencopys"
//                       value={Etoken}
//                     ></textarea>
//                     <button
//                       hidden={Etoken}
//                       className="btn btn-success mx-2"
//                       style={{
//                         backgroundColor: "rgb(10, 200, 150)",
//                         border: "none",
//                         borderRadius: "10px",
//                       }}
//                       onClick={GenerateTokenFor}
//                     >
//                       {t("Generate Token")}
//                     </button>
//                   </div>
//                 </div>
//                 <div className="form-group my-3">
//                   <label htmlFor="remark">
//                     {t("Remark (Required for Rejection):")}
//                   </label>
//                   <textarea
//                     className="form-control"
//                     name=""
//                     id=""
//                     placeholder={t("Enter Remark")}
//                     onChange={(e) => setRemark(e.target.value)}
//                   ></textarea>
//                 </div>
//                 <button
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     gap: "4px",
//                     background:
//                       "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                     width: "5rem",
//                     height: "2rem",
//                     fontSize: "18px",
//                   }}
//                   onClick={() => approveorrejectSelected("Rejected")}
//                   hidden={hide}
//                 >
//                   <img src={submit} style={{ width: "15px" }} /> {t("Reject")}
//                 </button>
//                 {/* <button className='btn btn-success mx-2' onClick={() => Reject(selectedType)} hidden={hide} >Reject</button> */}
//                 <button
//                   className="btn btn-danger"
//                   onClick={(x) => {
//                     SetGenerateRejectToken(true);
//                     SetEtoken("");
//                   }}
//                 >
//                   {t("close")}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {showSpecific === 1 && (
//         <div
//           className="col-12"
//           style={{
//             backgroundColor: "#EFF3F8",
//             height: "89vh",
//             overflowX: "hidden",
//             overflowY: "scroll",
//           }}
//         >
//           <div className="col-11 m-auto">
//             <div className="col-12 PartSection">
//               <div className="col-12 py-4">
//                 <div
//                   className="col-12"
//                   style={{
//                     backgroundColor: "white",
//                     borderRadius: "8px",
//                     padding: "20px",
//                     boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//                     marginBottom: "20px",
//                   }}
//                 >
//                   <h5 className="text-center fw-bold my-4">
//                     {t("Proposal ID")} : {selectedUploadId}
//                   </h5>

//                   {/* technicalInwards.Proposal_copy ?
//                             (<a href={`${apiurl}/ProposalFile/${technicalInwards.Proposal_copy}`} target='_blank'>{technicalInwards.Proposal_copy}</a>)
//                             :
//                             (<p className='text-danger my-auto fw-bold'>No Copy</p>) */}

//                   <div className="col-10 m-auto ImageContainer">
//                     <div className="row justify-content-center">
//                       {FetchedImages &&
//                         FetchedImages.length > 0 &&
//                         FetchedImages.map((val, index) => {
//                           const images = parseUploads(val.Upload);

//                           return images.map((img, imgIndex) => (
//                             <div
//                               key={`${index}-${imgIndex}`}
//                               className="col-12 col-sm-6 col-md-4 col-lg-3 px-2 my-2"
//                             >
//                               <div
//                                 className="uploadImagesContainer"
//                                 style={{
//                                   width: "100%",
//                                   height: "200px",
//                                   borderRadius: "20px",
//                                   overflow: "hidden",
//                                   cursor: "pointer",
//                                   border: "1px solid #ccc",
//                                 }}
//                                 onClick={() =>
//                                   setSelectedImage(`${apiurl}/uploads/${img}`)
//                                 }
//                               >
//                                 <img
//                                   src={`${apiurl}/uploads/${img}`}
//                                   alt="Uploaded"
//                                   style={{
//                                     width: "100%",
//                                     height: "100%",
//                                     objectFit: "cover",
//                                   }}
//                                 />
//                               </div>
//                             </div>
//                           ));
//                         })}
//                     </div>
//                   </div>

//                   <div className="col-12 text-center">
//                     <button
//                       className="btn btn-primary fw-bold px-5 my-4"
//                       onClick={() => setShowSpecific(0)}
//                     >
//                       {t("Back")}
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Modal or preview */}
//       {selectedImage && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             backgroundColor: "rgba(0,0,0,0.7)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 1000,
//           }}
//           onClick={() => setSelectedImage(null)}
//         >
//           <img
//             src={selectedImage}
//             alt="Uploaded"
//             style={{
//               maxWidth: "80%",
//               maxHeight: "80%",
//               borderRadius: "10px",
//               boxShadow: "0 0 10px white",
//             }}
//           />
//         </div>
//       )}
//     </>
//   );
// };

// export default ProgressReportInwardsList;

import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../StateContext/Application";
import { apiurl } from "../../../../path";
import { Link, useNavigate } from "react-router-dom";
import "./rejectpanel.css";
import {
  Back32,
  Cancel32,
  ProposalCreation32,
  submit,
} from "../../../../public/LoginImages/importimages";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import GooglePagination from "../../styles/GooglePagination";
import jsPDF from "jspdf";
import html2canvas from 'html2canvas';
import * as XLSX from "xlsx";

const ProgressReportInwardsList = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const {
    GetBudgetHeadInfo,
    ProgressReportApprovalOperation,
    CreateToken,
    GetProgressReportInwardList,
  } = context;
  const nav = useNavigate();
  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [showSpecific, setShowSpecific] = useState(0);
  const [loading, setLoading] = useState(false);
  const [exportingPDF, setExportingPDF] = useState(false);
  const [rejectPanelhide, setRejectpanelhide] = useState(1);
  const [remark, setRemark] = useState("");
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [progressData, setProgressData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImage1, setSelectedImage1] = useState(null);
  const [progressData1, setProgressData1] = useState([]);  
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [selectedImageIndex1, setSelectedImageIndex1] = useState(0);
  const [selectedUploadId, setSelectedUploadID] = useState();
  const [FetchedImages, setFetchedImages] = useState([]); const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const sortedBills = filteredBills;
              
  // const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  // const sortedBills = Array.isArray(filteredBills) ? filteredBills.slice() // ✅ prevent state mutation
  //   .sort((a, b) => new Date(b.Date) - new Date(a.Date))
  //   : [];

  const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
  const [hide, sethide] = useState(true);
  const [Etoken, SetEtoken] = useState(false);
  const [GenerateToken, SetGenerateToken] = useState(true);
  const [GenerateRejectToken, SetGenerateRejectToken] = useState(true);

  async function GenerateTokenFor(e) {
    e.preventDefault();
    let data = await CreateToken("Proposal Approval");
    document.getElementById("tokencopys").innerText = data;
    SetEtoken(data);
    sethide(false);
  }
  const headerStyle = {
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };
  const headerStyle2 = {
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };
  const getTechnicalInwardsList = async () => {
    let data = await GetProgressReportInwardList("All", "All");
    // const sortedData = data.sort((a, b) =>
    //   new Date(a.Date) - new Date(b.Date)
    // );
    const sortedData = data;
    console.log("data-----------", sortedData);
    setTechnicalInwards(sortedData);
    setFilteredBills(sortedData);
  };

  useEffect(() => {
    getTechnicalInwardsList();
  }, []);

  let inwardList = [];
  if (technicalInwards.length > 0) {
    inwardList = technicalInwards;
  }
  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const filtered = technicalInwards.filter((bill) =>
      Object.values(bill).some((val) =>
        (val || "").toString().toLowerCase().includes(lowerSearchTerm),
      ),
    );
    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [searchTerm, technicalInwards]);

  // const handleCheckboxChange = (techincaluid,physicalwork) => {
  //     const key = `${techincaluid}-${physicalwork}`
  //     setSelectedBills((prevSelected) =>
  //         prevSelected.includes(key)
  //             ? prevSelected.filter((billId) => billId !== key)
  //             : [...prevSelected, key]
  //     );
  // };

  const handleCheckboxChange = (id) => {
    setSelectedBills((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  console.log("Slected id form table :: ", selectedBills);
  console.log("Filtered data id form table :: ", filteredBills);

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    const currentPageIds = currentBills.map((b) => b.ID);

    setSelectedBills((prev) => {
      if (checked) {
        // ✅ add current page IDs without duplicates
        return Array.from(new Set([...prev, ...currentPageIds]));
      } else {
        // ✅ remove only current page IDs
        return prev.filter((id) => !currentPageIds.includes(id));
      }
    });
  };

  //want to send MHUID and physicalvalue
  const selectedRows = filteredBills.filter((row) =>
    selectedBills.includes(row.ID),
  );
  const findMHUID = selectedRows.map((r) => r.TechnicalUID);
  const physical = selectedRows.map((r) => r.physicalValue);
  const uploadId = selectedRows.map((r) => r.UploadID);
  console.log("ffasd", selectedRows, findMHUID, physical);

  // const approveorrejectSelected = async (condition) => {
  //     if (selectedBills.length === 0) {
  //         alert('No Proposal selected for approval!');
  //         return;
  //     }
  //     console.log(selectedBills);
  //     setLoading(true); // Start loader

  //     try {
  //         let response = await ProgressReportApprovalOperation(selectedBills, condition, remark, Etoken); // Call backend function
  //         if (response.message) {
  //             alert(response.message);
  //             window.location.reload()
  //             setRemark("");
  //             setRejectpanelhide(false)
  //             getTechnicalInwardsList(); // Refresh the list after approval
  //         }
  //         if (response.error) {
  //             alert(response.error)
  //             window.location.reload()
  //             getTechnicalInwardsList(); // Refresh the list after approval
  //         }
  //     } catch (error) {
  //         console.error('Error approving Proposal:', error);
  //         alert('An error occurred while approving bills.');
  //     }
  //     setLoading(false); // Stop loader
  // };

  // const approveorrejectSelected = async (condition) => {
  //     if (selectedBills.length === 0) {
  //         alert('No Proposal selected for approval!');
  //         return;
  //     }
  //     console.log("hfdfsfs", selectedBills);
  //     setLoading(true); // Start loader

  //     try {
  //         let response = await ProgressReportApprovalOperation(selectedBills, condition, remark, findMHUID, physical, Etoken); // Call backend function
  //         if (response.message) {
  //             alert(response.message);

  //             setSelectedBills([]);          // ✅ RESET SELECTION
  //             setRejectpanelhide(1);
  //             setRemark("");

  //             getTechnicalInwardsList();     // refresh data
  //         }
  //         if (response.error) {
  //             alert(response.error)
  //             window.location.reload()
  //             getTechnicalInwardsList(); // Refresh the list after approval
  //         }
  //     } catch (error) {
  //         console.error('Error approving Proposal:', error);
  //         alert('An error occurred while approving bills.');
  //     }
  //     setLoading(false); // Stop loader
  // };

  /////OBject passing
  const approveorrejectSelected = async (condition) => {
    if (selectedBills.length === 0) {
      alert("No Proposal selected for approval!");
      return;
    }
    if (condition == "Rejected" || condition == "SendBack") {
      const cleanRemark = remark.trim().replace(/\s+/g, " ");

      // ❌ If remark is empty after trimming
      if (!cleanRemark) {
        alert("Remark is required and cannot be empty!");
        return;
      }
    }
    setLoading(true); // Start loader

    try {
      const payload = selectedBills.map((bill, index) => ({
        id: bill,
        MHUID: findMHUID[index],
        physicalValue: physical[index],
        remark,
        type: condition,
        UploadID: uploadId[index],
      }));
      console.log("type", selectedBills[0].condition);

      console.log("payload", payload);
      let response = await ProgressReportApprovalOperation(payload, Etoken);
      if (response.message) {
        alert(response.message);
        window.location.reload();
        setRemark("");
        setRejectpanelhide(false);
        getTechnicalInwardsList(); // refresh data
      }
      if (response.error) {
        alert(response.error);
        window.location.reload();
        getTechnicalInwardsList(); // Refresh the list after approval
      }
    } catch (error) {
      console.error("Error approving Proposal:", error);
      alert("An error occurred while approving bills.");
    }
    setLoading(false); // Stop loader
  };

 
  const fetchSpecficUploadPhoto = async (headCode, workName, physicalWork) => {
    console.log("here-photo", headCode, workName, physicalWork);
    let HeadCode = { headCode: headCode, workName: workName };
    try {
      let res = await GetBudgetHeadInfo(
        HeadCode,
        "GetSpecificUploadImagesfromProgressTable",
      );
      const filteredImages = res.filter(
        (img) => img.physicalValue === physicalWork,
      );
      console.log("filteredImages", filteredImages);
      setFetchedImages(filteredImages);
      setSelectedUploadID(workName);
      setShowSpecific(1);
    } catch (err) {
      console.log(err);
    }
  };

  const rejectSendbackbeforecheckup = (id) => {
    if (selectedBills.length > 0) {
      setRejectpanelhide(id);
    } else {
      alert("No Bill Selected !!!");
    }
  };

  const navigatetoMap = async (mhuid) => {
    setLoading(true);
    try {
      let res = await GetBudgetHeadInfo(
        mhuid,
        "GetSpecificTechincalSanctionInfoBYSanctionNo",
      );

      if (res && res.length <= 0) {
        alert("No Location Found");
        return;
      }

      let technicaldata = res[0];

      if (technicaldata.MultipleGramPanchayat === "Yes") {
        const fetchurl = `https://grammanchitra.gov.in/gpassetsCollectionMH?dpcode=${technicaldata.DPCode}&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3MTcxNDM5OTksImV4cCI6MTcxNzE1MTE5OSwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NzAzNC8iLCJhdWQiOiJodHRwczovL2xvY2FsaG9zdDo3MDM0LyJ9.Yb3a_9eB5DEC9OeGfO7GoUgqxnhfRDF6fZMHdPhW3hg&activityCode=${technicaldata.Proposal_UID}&forRddAssetCode=true&projectId=${technicaldata.Proposal_UID}&rddassetCode=${technicaldata.GR_UID}`;
        window.open(fetchurl, "_blank");
      } else if (technicaldata.MultipleGramPanchayat === "No") {
        const fetchurl = `https://grammanchitra.gov.in/gpassetsCollectionMH?gpcode=${technicaldata.GPCode}&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3MTcxNDM5OTksImV4cCI6MTcxNzE1MTE5OSwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NzAzNC8iLCJhdWQiOiJodHRwczovL2xvY2FsaG9zdDo3MDM0LyJ9.Yb3a_9eB5DEC9OeGfO7GoUgqxnhfRDF6fZMHdPhW3hg&activityCode=${technicaldata.Proposal_UID}&forRddAssetCode=true&projectId=${technicaldata.Proposal_UID}&rddassetCode=${technicaldata.GR_UID}`;
        window.open(fetchurl, "_blank");
      }
    } catch (err) {
      setLoading(false);
      alert("Interval Server Error");
    } finally {
      setLoading(false);
    }
  };

  const parseUploads = (upload) => {
    try {
      if (Array.isArray(upload)) return upload;
      return JSON.parse(upload || "[]");
    } catch {
      return [];
    }
  };

  const parseLocations = (location) => {
    try {
      if (Array.isArray(location)) {
        return location.map((loc) =>
          typeof loc === "string" ? JSON.parse(loc) : loc,
        );
      }

      const parsed = JSON.parse(location || "[]");

      return parsed.map((loc) =>
        typeof loc === "string" ? JSON.parse(loc) : loc,
      );
    } catch {
      return [];
    }
  };

    const openProgressModal = (images, location) => {
      console.log("image and location ", images ,location)
      try {
        const parsedImages = JSON.parse(images || "[]");
        const parsedLocations = JSON.parse(location || "[na]");
  
        let imageArray = [];
  
        parsedImages.forEach((img) => {
          try {
            const nested = JSON.parse(img);
  
            if (Array.isArray(nested)) {
              imageArray.push(...nested);
            } else {
              imageArray.push(img);
            }
          } catch {
            imageArray.push(img);
          }
        });
  
        // const combinedData = imageArray.map((image, index) => {
        //   let locationObj = {};
  
        //   try {
        //     locationObj = JSON.parse(parsedLocations[index] || "{}");
        //   } catch (err) {
        //     console.log(err);
        //   }
  
        //   return {
        //     image,
        //     location: locationObj,
        //   };
        // });
  const combinedData = imageArray.map((image, index) => {
    let locationObj = {};
  
    const loc = parsedLocations[index];
  
    if (
      loc &&
      loc !== "na" &&
      loc !== "null" &&
      loc !== ""
    ) {
      try {
        locationObj = JSON.parse(loc);
      } catch (err) {
        console.error("Invalid location JSON:", loc, err);
      }
    }
  
    return {
      image,
      location: locationObj,
    };
  });
        console.log("combinedData", combinedData);
  
        setProgressData(combinedData);
        setShowProgressModal(true);
      } catch (err) {
        console.log(err);
      }
    };
  //  useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     if (!progressData1?.length) return;
  
  //     if (e.key === "ArrowRight") {
  //       setSelectedImageIndex1((prevIndex) =>
  //         (prevIndex + 1) % progressData1.length
  //       );
  //     }
  
  //     if (e.key === "ArrowLeft") {
  //       setSelectedImageIndex1((prevIndex) =>
  //         (prevIndex - 1 + progressData1.length) % progressData1.length
  //       );
  //     }
  
  //     // Optional: close image/modal with Escape
  //     // if (e.key === "Escape") {
  //     //   setSelectedImageIndex(null);
  //     // }
  //   };
  
  //   window.addEventListener("keydown", handleKeyDown);
  
  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, [progressData1]);
  
  useEffect(() => {
  const handleKeyDown = (e) => {
    if (!progressData1?.length || !selectedImage) return;

    if (e.key === "ArrowRight") {
      setSelectedImageIndex1((prevIndex) => {
        const nextIndex = (prevIndex + 1) % progressData1.length;

        setSelectedImage(
          `${apiurl}/uploads/${progressData1[nextIndex]}`
        );

        return nextIndex;
      });
    }

    if (e.key === "ArrowLeft") {
      setSelectedImageIndex1((prevIndex) => {
        const prevImageIndex =
          (prevIndex - 1 + progressData1.length) %
          progressData1.length;

        setSelectedImage(
          `${apiurl}/uploads/${progressData1[prevImageIndex]}`
        );

        return prevImageIndex;
      });
    }

    if (e.key === "Escape") {
      setSelectedImage(null);
    }
  };

  window.addEventListener("keydown", handleKeyDown);

  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
}, [progressData1, selectedImage, apiurl]);
useEffect(() => {
    const handleKeyDown = (e) => {
      if (!progressData?.length) return;
  
      if (e.key === "ArrowRight") {
        setSelectedImageIndex((prevIndex) =>
          (prevIndex + 1) % progressData.length
        );
      }
  
      if (e.key === "ArrowLeft") {
        setSelectedImageIndex((prevIndex) =>
          (prevIndex - 1 + progressData.length) % progressData.length
        );
      }
  
      // Optional: close image/modal with Escape
      // if (e.key === "Escape") {
      //   setSelectedImageIndex(null);
      // }
    };
  
    window.addEventListener("keydown", handleKeyDown);
  
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [progressData]);

  ////////////
  const exportTableByClassToExcel = async (
    filteredBills,
    filename = "Progress_Report.xlsx"
  ) => {
    if (!Array.isArray(filteredBills) || filteredBills.length === 0) {
      alert("No data available");
      return;
    }
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      let totalProposalAmount = 0;

      const excelData = filteredBills.map((proposal, index) => {
        const amount = Number(proposal.Proposal_amount || 0);
        totalProposalAmount += amount;

        let gramPanchayat = "";
        try {
          gramPanchayat = proposal.gram_panchayat
            ? JSON.parse(proposal.gram_panchayat).join(", ")
            : "";
        } catch {
          gramPanchayat = "";
        }

        return {
          "Sr.No": index + 1,
          "Head Code": proposal.Head_Code || "",
          "Proposal Year": proposal.ProposalYear || "",
          "Work Name": proposal.WorkOrderNo || "",
          "Job ID": proposal.JOB_ID || "-",
          // "MHUID Number": proposal.TechnicalUID || "-",
          "MHUID Number":
            !proposal.TechnicalUID ||
            String(proposal.TechnicalUID).trim().toUpperCase() === "NULL" ||
            String(proposal.TechnicalUID).trim().toLowerCase() === "undefined" ||
            String(proposal.TechnicalUID).trim() === ""
              ? "-"
              : proposal.TechnicalUID,
          "Gram Panchayat": proposal.gram_panchayat || "",
          "District": proposal.District || "",
          "Uploaded Date": proposal.Date
            ? new Date(proposal.Date).toLocaleString()
            : "",
          "Remarks": proposal.Remark || "-",
          // "Taluka": proposal.Taluka || "",
          // "Constituency Name": proposal.Constituency_name || "",
          // "Proposal File Number": proposal.Proposal_fileNumber || "",
          // "Work Amount": proposal.Proposal_amount,
          // "Class of Work": proposal.classOfWork || "",
        };
      });

      // TOTAL ROW
      excelData.push({
        "Sr.No": "",
        "Head Code": "",
        "Proposal Year": "",
        "Work Name": "",
        "Job ID": "",
        "MHUID Number": "",
        "Gram Panchayat": "",
        "District": "",
        "Uploaded Date": "",
        "Remarks": "",

        // "Year": "",
        // "Taluka": "",
        // "Constituency Name": "",
        // "Proposal File Number": "TOTAL",
        // "Work Amount": totalProposalAmount,
        // "Class of Work": "",
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({ wch: 22 }));
      worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: { r: excelData.length, c: Object.keys(excelData[0]).length - 1 }
        })
      };

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Proposals");
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Excel Export Error:", error);
    } finally {
      setLoading(false); // ✅ ALWAYS stop loader
    }
  }

  const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
    const CHUNK_SIZE = 500; // 🔥 adjust (300–500 recommended)

    setExportingPDF(true);
    setLoading(true);

    // Allow loader to render
    await new Promise((resolve) => setTimeout(resolve, 600));

    const originalTable = document.querySelector(`.${tableClass}`);
    if (!originalTable) {
      setExportingPDF(false);
      setLoading(false);
      return;
    }

    try {
      const originalRows = originalTable.querySelectorAll("tbody tr");
      const totalRows = originalRows.length;

      for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
        const end = Math.min(start + CHUNK_SIZE, totalRows);

        // 🔥 Clone table
        const table = originalTable.cloneNode(true);
        const rows = table.querySelectorAll("tbody tr");

        // Remove rows outside chunk
        rows.forEach((row, index) => {
          if (index < start || index >= end) {
            row.remove();
          }
        });

        document.body.appendChild(table);

        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const topMargin = 25;
        const sideMargin = 10;
        const bottomMargin = 15;

        pdf.setFontSize(16);
        pdf.setFont("helvetica", "bold");
        pdf.text(
          `${title} (${start + 1} - ${end})`,
          pageWidth / 2,
          15,
          { align: "center" }
        );

        const canvas = await html2canvas(table, {
          scale: 1,
          useCORS: true,
          backgroundColor: "#2C78DB",
        });

        const imgWidth = pageWidth - sideMargin * 2;
        const pxToMm = imgWidth / canvas.width;

        const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
        const usablePageHeightPx = usablePageHeightMm / pxToMm;

        let renderedHeight = 0;
        let pageNumber = 0;

        while (renderedHeight < canvas.height) {
          const sliceHeight = Math.min(
            usablePageHeightPx,
            canvas.height - renderedHeight
          );

          const pageCanvas = document.createElement("canvas");
          const context = pageCanvas.getContext("2d");

          pageCanvas.width = canvas.width;
          pageCanvas.height = sliceHeight;

          context.drawImage(
            canvas,
            0,
            renderedHeight,
            canvas.width,
            sliceHeight,
            0,
            0,
            canvas.width,
            sliceHeight
          );

          const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

          if (pageNumber > 0) pdf.addPage();

          pdf.addImage(
            imgData,
            "JPEG",
            sideMargin,
            topMargin,
            imgWidth,
            sliceHeight * pxToMm
          );

          renderedHeight += sliceHeight;
          pageNumber++;
        }

        pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

        document.body.removeChild(table);

        await new Promise((resolve) => setTimeout(resolve, 300));
      }
    } catch (error) {
      console.error("PDF Export Error:", error);
    } finally {
      setExportingPDF(false);
      setLoading(false);
    }
  };

  return (
    <>
      {showSpecific === 0 && (
        <div>
          <div
            sclass="col-12"
            style={{
              backgroundColor: "#EFF3F8",
              height: "89vh",
              overflowX: "hidden",
              overflowY: "scroll",
            }}
          >
            <div className="col-11 m-auto">
              <div className="col-12">
                  <div
                  className="col-12 px-4 mb-4 mt-3"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h5 className="my-auto fw-bold">
                    <img
                      src="/GR-Approval64.png"
                      alt="Technical Approval"
                      style={{ width: "24px", height: "24px" }}
                      className="my-auto me-1"
                    />
                    <span className="my-auto">
                      {t("Progress Report Inward List")}
                    </span>
                  </h5>
                  <div
                    style={{
                      position: "relative",
                      width: "250px",
                      marginRight: "10px",
                    }}
                  >
                    <img
                      src="/Search32.png"
                      alt="Search Icon"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        width: "16px",
                        height: "16px",
                        opacity: 0.6,
                      }}
                    />
                    <input
                      type="text"
                      placeholder={t("Search")}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      value={searchTerm}
                      style={{
                        width: "100%",
                        padding: "8px 12px 8px 32px", // left padding makes space for icon
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#f1f6fc",
                        fontSize: "14px",
                        color: "#333",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                        outline: "none",
                      }}
                    />
                  </div>
                </div>

                {/* ////// */}
                <div
                  className="d-flex justify-content-end align-items-center mb-2 flex-wrap"
                  style={{ gap: "10px" }}
                >
                  <button
                    className="btn btn-success"
                    onClick={() =>
                      exportTableByClassToExcel(filteredBills, "Progress_Report.xlsx")
                    }
                  >
                    {t("Download Excel")}
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={() =>
                      downloadTableOnlyAsPDF(
                        "ProgressReportTable",
                        "ProgressReport.pdf",
                        "Progress Report"
                      )
                    }
                  >
                    {t("Download PDF")}
                  </button>
                </div>
                {/* ////// */}

                
                <div className="col-12 pb-5">
                  <div
                    lassName="col-12 mb-3"
                    style={{
                      backgroundColor: "white",
                      padding: "30px 40px ",
                      boxShadow: "0px 0px 5px 1px #E4E8EC",
                      borderRadius: "20px",
                      width: "fit-content",
                    }}
                  >
                    <div
                      className="col-12 tableDesign"
                      style={{
                        // background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )',
                        background: "#2C78DB",
                        display: "flex",
                        width: "70vw",
                        overflowX: "auto",
                        border: "1px solid #3b409e",
                      }}
                    >
                      <table
                        className="m-0 p-0 ProgressReportTable"
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead  style={{
                            position: "sticky",
                            backgroundColor: "#1976d2",
                            top: 0,
                            zIndex: 10,
                          }}>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                            }}
                          >
                            <th style={headerStyle}>
                              <input
                                type="checkbox"
                                onChange={handleSelectAll}
                                checked={
                                  currentBills.length > 0 &&
                                  currentBills.every((bill) =>
                                    selectedBills.includes(bill.ID),
                                  )
                                }
                                className="my-auto"
                                style={{ height: "1rem", width: "1rem" }}
                              />
                            </th>
                            <th style={headerStyle}>{t("Sr.No.")}</th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Head Code")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Proposal Year")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Word Order Name")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Job ID")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("MHUID Number")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Gram Panchayat")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("District")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Uploaded Date")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Physical Progress (%)")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Remark")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Action")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("View Map")}
                            </th>
                            {/* <th style={{ width: "14%" }}>Proposal amount (In CR)</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {currentBills?.length === 0 ? (
                            <tr>
                              <td
                                colSpan="14"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                {t("No data available")}
                              </td>
                            </tr>
                          ) : (
                            currentBills?.map((technicalInwards, index) => {
                              const bgColor =
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                              console.log(
                                "technicalInwards.Head_Code",
                                technicalInwards,
                              );
                              return (
                                <tr
                                  className="px-3"
                                  key={index}
                                  style={{
                                    backgroundColor: bgColor,
                                    fontSize: "18px",
                                    fontWeight: "400",
                                  }}
                                >
                                  <td style={{ textAlign: "center" }}>
                                    {/* <input
                                                                            type="checkbox"
                                                                            className='my-auto'
                                                                            style={{ height: '1rem', width: '1rem' }}
                                                                            checked={selectedBills.includes(`${technicalInwards.TechnicalUID}-${technicalInwards.physicalValue}`)}
                                                                            onChange={() => handleCheckboxChange(technicalInwards.TechnicalUID,technicalInwards.physicalValue)}
                                                                        /> */}
                                    <input
                                      type="checkbox"
                                      className="my-auto"
                                      style={{ height: "1rem", width: "1rem" }}
                                      checked={selectedBills.includes(
                                        technicalInwards.ID,
                                      )}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          technicalInwards.ID,
                                        )
                                      }
                                    />
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {indexOfFirstBill + index + 1}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {technicalInwards.Head_Code}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {technicalInwards.ProposalYear}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {technicalInwards.WorkOrderNo}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {technicalInwards.JOB_ID ?? "-"}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {/* {technicalInwards.TechnicalUID} */}
                                    {!technicalInwards.TechnicalUID ||
                                     String(technicalInwards.TechnicalUID).trim().toUpperCase() === "NULL" ||
                                     String(technicalInwards.TechnicalUID).trim().toLowerCase() === "undefined" ||
                                     String(technicalInwards.TechnicalUID).trim() === ""
                                       ? "-"
                                       : technicalInwards.TechnicalUID}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {technicalInwards.gram_panchayat ?? "-"}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {technicalInwards.District}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {new Date(
                                      technicalInwards.Date,
                                    ).toLocaleString("en-IN")}
                                  </td>
                                  {/* <td style={{ padding: "8px 8px" }}>
                                    {technicalInwards.physicalValue ?? "-"}
                                  </td> */}
                                           <td>
                              <span
                                style={{
                                  color: "blue",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  openProgressModal(
                                    technicalInwards.Upload,
                                    technicalInwards.Location,
                                  )
                                }
                              >
                                {technicalInwards.physicalValue}%
                              </span>
                            </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {technicalInwards.Remark}
                                  </td>
                                  {/* <td className='py-2'>{technicalInwards.Proposal_fileNumber}</td> */}
                                  {/* <td className='py-2'>{
                                                        technicalInwards.Proposal_copy ?
                                                            (<a href={`${apiurl}/ProposalFile/${technicalInwards.Proposal_copy}`} target='_blank'>{technicalInwards.Proposal_copy}</a>)
                                                            :
                                                            (<p className='text-danger my-auto fw-bold'>No Copy</p>)
                                                    }
                                                    </td>
                                                    <td style={{ padding: '8px' }}>{
                                                        technicalInwards.Additional_suppDoc ?
                                                            (<a href={`${apiurl}/ProposalFile/${technicalInwards.Additional_suppDoc}`} target='_blank'>{technicalInwards.Additional_suppDoc}</a>)
                                                            :
                                                            (<p className='text-danger my-auto fw-bold'>No Copy</p>)
                                                    }
                                                    </td> */}
                                  <td
                                    style={{
                                      padding: "8px 8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <button
                                      className="btn btn-success px-3"
                                      onClick={() =>
                                        fetchSpecficUploadPhoto(
                                          technicalInwards.Head_Code,
                                          technicalInwards.WorkOrderNo,
                                          technicalInwards.physicalValue,
                                        )
                                      }
                                      style={{
                                        fontSize: "18px",
                                        background:
                                          "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                        color: "white",
                                        border: "none",
                                        padding: "6px 12px",
                                        borderRadius: "8px",
                                        display: "inline-flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "4px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {t("View Photos")}
                                    </button>
                                  </td>
                                  <td
                                    style={{
                                      padding: "8px 8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <button
                                      onClick={() =>
                                        navigatetoMap(
                                          technicalInwards.TechnicalUID,
                                        )
                                      }
                                      style={{
                                        cursor: "pointer",
                                        background:
                                          "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                        color: "white",
                                        border: "none",
                                        padding: "6px 10px",
                                        borderRadius: "8px",
                                        fontSize: "18px",
                                        display: "inline-flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "4px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {t("Go to Map")}
                                    </button>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Showing entries & Pagination */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "20px",
                        padding: "0 12px",
                        fontSize: "18px"
                      }}
                    >
                      {/* Left side - Showing entries */}
                      <p style={{ margin: 0 }}>
                        {t("Showing")}{" "}
                        {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
                        {t("to")}{" "}
                        {Math.min(indexOfLastBill, filteredBills.length)}{" "}
                        {t("of")} {technicalInwards?.length} {t("entries")}
                      </p>

                      {/* Right side - Pagination */}
                      <div>
                        <GooglePagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPageChange={setCurrentPage}
                        />
                      </div>
                    </div>
                    {/* Approve / Reject buttons */}
                    <div
                      className="my-2"
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className="ms-0"
                        onClick={() => approveorrejectSelected("Approved")}
                        disabled={selectedBills.length <= 0 ? true : loading}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.3rem",
                          margin: "12px",
                          padding: "8px 10px",
                          fontWeight: "600",
                          backgroundColor:
                            selectedBills.length <= 0
                              ? "rgba(141, 141, 141, 0.97)"
                              : "#39B54A",
                          color: "white",
                          borderRadius: "8px",
                          cursor:
                            selectedBills.length <= 0
                              ? "not-allowed"
                              : loading
                                ? "not-allowed"
                                : "pointer",
                        }}
                      >
                        <img
                          src="/Approve-Selected32.png"
                          style={{
                            width: "1rem",
                            height: "1rem",
                            filter: "brightness(0) invert(1)",
                          }}
                        />
                        {loading ? t("Processing...") : t("Approve Selected")}
                      </button>

                      <button
                        onClick={() => rejectSendbackbeforecheckup(2)}
                        disabled={selectedBills.length <= 0 ? true : loading}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.3rem",
                          margin: "12px",
                          padding: "8px 10px",
                          fontWeight: "600",
                          background:
                            selectedBills.length <= 0
                              ? "rgba(141, 141, 141, 0.97)"
                              : "#C1272D",
                          color: "white",
                          borderRadius: "8px",
                          cursor:
                            selectedBills.length <= 0
                              ? "not-allowed"
                              : loading
                                ? "not-allowed"
                                : "pointer",
                        }}
                      >
                        <img
                          src="/Reject-Selected32.png"
                          style={{
                            width: "1rem",
                            height: "1rem",
                            filter: "brightness(0) invert(1)",
                          }}
                        />{" "}
                        {loading ? "Processing..." : t("Reject Selected")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {rejectPanelhide === 2 && (
            <div className="col-12 RejectPanelContainer"
            style={{
    position: "fixed",
    inset: 0,
    zIndex: 99999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
  }}>
              <div className="Rejectpanel"
                  style={{
      position: "relative",
      zIndex: 100000,
    }}>
                <form action="">
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-3">
                        <label className="fw-bold">
                          {t("Remark")} <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-8">
                        <textarea
                          name=""
                          id=""
                          placeholder={t("Enter Remark")}
                          value={remark}
                          onChange={(e) =>
                            setRemark(e.target.value.replace(/^\s+/, ""))
                          }
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="col-12 ms-auto my-4">
                  <div className="row">
                    <div className="col-9 m-auto">
                      <div
                        className="col-12"
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            background:
                              "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                            width: "5rem",
                            height: "2rem",
                            fontSize: "18px",
                          }}
                          onClick={() => approveorrejectSelected("Rejected")}
                        >
                          <img src={submit} style={{ width: "15px" }} />{" "}
                          {t("Reject")}
                        </button>
                        <button
                          type="button"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            backgroundColor: "#f1594c",
                            width: "6rem",
                            height: "2rem",
                            fontSize: "16px",
                          }}
                          onClick={() => window.location.reload()}
                        >
                          {" "}
                          <img src={Cancel32} style={{ width: "17px" }} />
                          {t("Cancel")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* {
                        rejectPanelhide === 3 &&

                        <div className='col-12 RejectPanelContainer'>
                            <div className="Rejectpanel">
                                <form action="">

                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-3">
                                                <label className='fw-bold'>Remark <span className='text-danger'>*</span></label>
                                            </div>
                                            <div className="col-8">
                                                <textarea name="" id="" placeholder='Enter Remark' onChange={(e) => setRemark(e.target.value)}>
                                                </textarea>
                                            </div>
                                        </div>
                                    </div>

                                </form>
                                <div className="col-12 ms-auto my-4">
                                    <div className="row">
                                 
                                        <div className="col-9 m-auto">
                                            <div className="col-12" style={{ display: 'flex', gap: '10px', justifyContent: "center" }}>
                                                <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '8rem', height: '2rem', fontSize: '18px' }} onClick={() => approveorrejectSelected("SendBack")}><img src={submit} style={{ width: '15px' }} /> Send Back</button>
                                                <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1594c', width: '6rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}> <img src={Cancel32} style={{ width: '17px' }} />Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    } */}

          <div className="card">
            <div
              style={{
                position: "fixed",
                padding: "10rem",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(5px)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
              hidden={GenerateToken}
            >
              <div
                class="card-body"
                style={{ backgroundColor: "white", width: "50%" }}
              >
                <h6>{t("Send Message")}</h6>
                <div class="card form-control" style={{ width: "100%" }}>
                  <div class="card-body">
                    <h5 class="card-title">{t("Generate Token")}</h5>
                    <textarea
                      class="form-control"
                      id="tokencopys"
                      value={Etoken}
                    ></textarea>
                    <button
                      hidden={Etoken}
                      className="btn btn-success mx-2"
                      style={{
                        backgroundColor: "rgb(10, 200, 150)",
                        border: "none",
                        borderRadius: "10px",
                      }}
                      onClick={GenerateTokenFor}
                    >
                      {t("Generate Token")}
                    </button>
                  </div>
                </div>
                <button
                  onClick={() => approveorrejectSelected("Approved")}
                  hidden={hide}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    margin: "12px",
                    padding: "8px 15px",
                    background:
                      "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
                    color: "white",
                    borderRadius: "5px",
                    cursor: loading ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    style={{ width: "14px", filter: "brightness(0) invert(1)" }}
                  />{" "}
                  {loading ? "Processing..." : "Approve Selected"}
                </button>
                {/* <button className='btn btn-success mx-2 my-2' onClick={() => Approve(selectedType)} hidden={hide} >Approve</button> */}
                <button
                  className="btn btn-danger"
                  onClick={(x) => {
                    SetGenerateToken(true);
                    SetEtoken("");
                  }}
                >
                  close
                </button>
              </div>
            </div>
          </div>

          <div className="card">
            <div
              style={{
                position: "fixed",
                padding: "10rem",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(5px)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
              hidden={GenerateRejectToken}
            >
              <div class="card-body" style={{ backgroundColor: "white" }}>
                <h6>{t("Send Message")}</h6>
                <div class="card form-control" style={{ width: "100%" }}>
                  <div class="card-body">
                    <h5 class="card-title">{t("Generate Token")}</h5>
                    <textarea
                      class="form-control"
                      id="tokencopys"
                      value={Etoken}
                    ></textarea>
                    <button
                      hidden={Etoken}
                      className="btn btn-success mx-2"
                      style={{
                        backgroundColor: "rgb(10, 200, 150)",
                        border: "none",
                        borderRadius: "10px",
                      }}
                      onClick={GenerateTokenFor}
                    >
                      {t("Generate Token")}
                    </button>
                  </div>
                </div>
                <div className="form-group my-3">
                  <label htmlFor="remark">
                    {t("Remark (Required for Rejection):")}
                  </label>
                  <textarea
                    className="form-control"
                    name=""
                    id=""
                    placeholder={t("Enter Remark")}
                    value={remark}
                    onChange={(e) =>
                      setRemark(e.target.value.replace(/^\s+/, ""))
                    }
                  ></textarea>
                </div>
                <button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "4px",
                    background:
                      "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                    width: "5rem",
                    height: "2rem",
                    fontSize: "18px",
                  }}
                  onClick={() => approveorrejectSelected("Rejected")}
                  hidden={hide}
                >
                  <img src={submit} style={{ width: "15px" }} /> {t("Reject")}
                </button>
                {/* <button className='btn btn-success mx-2' onClick={() => Reject(selectedType)} hidden={hide} >Reject</button> */}
                <button
                  className="btn btn-danger"
                  onClick={(x) => {
                    SetGenerateRejectToken(true);
                    SetEtoken("");
                  }}
                >
                  {t("close")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSpecific === 1 && (
        <div
          className="col-12"
          style={{
            backgroundColor: "#EFF3F8",
            height: "89vh",
            overflowX: "hidden",
            overflowY: "scroll",
          }}
        >
          <div className="col-11 m-auto">
            <div className="col-12 PartSection">
              <div className="col-12 py-4">
                <div
                  className="col-12"
                  style={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    padding: "20px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    marginBottom: "20px",
                  }}
                >
                  <h5 className="text-center fw-bold my-4">
                    {t("Proposal ID")} : {selectedUploadId}
                  </h5>

                  {/* technicalInwards.Proposal_copy ?
                            (<a href={`${apiurl}/ProposalFile/${technicalInwards.Proposal_copy}`} target='_blank'>{technicalInwards.Proposal_copy}</a>)
                            :
                            (<p className='text-danger my-auto fw-bold'>No Copy</p>) */}

                         <div className="col-10 m-auto ImageContainer">
                    <div className="row justify-content-center">
                      {FetchedImages &&
                        FetchedImages.length > 0 &&
                        FetchedImages.map((val, index) => {
                          const images = parseUploads(val.Upload);
                          const locations = parseLocations(val.Location);

                          return images.map((img, imgIndex) => {
                            const location = locations[imgIndex] || {};

                            return (
                              <div
                                key={`${index}-${imgIndex}`}
                                className="col-12 col-sm-6 col-md-4 col-lg-3 px-2 my-2"
                              >
                                <div
                                  style={{
                                    border: "1px solid #ddd",
                                    borderRadius: "12px",
                                    padding: "10px",
                                    background: "#fff",
                                  }}
                                >
                                  <div
                                    className="uploadImagesContainer"
                                    style={{
                                      width: "100%",
                                      height: "200px",
                                      borderRadius: "10px",
                                      overflow: "hidden",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setSelectedImage(
                                        `${apiurl}/uploads/${img}`,
                                      );
                                      setSelectedImageIndex1(index);
                                      setProgressData1(images);
                                    }}
                                  >
                                    <img
                                      src={`${apiurl}/uploads/${img}`}
                                      alt="Uploaded"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </div>

                                  <div
                                    style={{
                                      marginTop: "10px",
                                      fontSize: "13px",
                                      lineHeight: "1.6",
                                    }}
                                  >
                                    <div>
                                      📍 Latitude: {location.latitude || "-"}
                                    </div>
                                    <div>
                                      📍 Longitude: {location.longitude || "-"}
                                    </div>
                                    <div>📅 Date: {location.date || "-"}</div>
                                    <div>🕒 Time: {location.time || "-"}</div>
                                    <div>
                                      ⛰️ Elevation: {location.elevation || "-"}{" "}
                                      m
                                    </div>
                                    <div>
                                      🎯 Accuracy: {location.accuracy || "-"} m
                                    </div>
                                    <div>
                                      📊 Physical Done:{" "}
                                      {val.physicalValue || "-"}%
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          });
                        })}
                    </div>
                  </div>
                  <div className="col-12 text-center">
                    <button
                      className="btn btn-primary fw-bold px-5 my-4"
                      onClick={() => setShowSpecific(0)}
                    >
                      {t("Back")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal or preview */}
 {selectedImage && (
        <div
          //  onClick={() => setShowImageModal(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();

              const prevIndex =
                (selectedImageIndex1 - 1 + progressData1.length) %
                progressData1.length;

              setSelectedImageIndex1(prevIndex);
                setSelectedImage(
      `${apiurl}/uploads/${progressData1[prevIndex]}`
    );
            }}
            style={{
              position: "absolute",
              left: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "30px",
              background: "rgba(0,0,0,0.5)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "45px",
              height: "45px",
              cursor: "pointer",
            }}
          >
            ❮
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImage(null);
            }}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              fontSize: "30px",
              color: "#fff",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              zIndex: 10001,
            }}
          >
            ×
          </button>
   
          <img
            src={selectedImage}
      alt="Preview"
      onClick={(e) => e.stopPropagation()}
     
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: "20px",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
              background: "rgba(0,0,0,0.5)",
              padding: "6px 12px",
              borderRadius: "20px",
            }}
          >
            {selectedImageIndex1 + 1} / {progressData1.length}
          </div>
          <button
          onClick={(e) => {
    e.stopPropagation();

    if (!progressData1?.length) return;

    const nextIndex =
      (selectedImageIndex1 + 1) % progressData1.length;

    setSelectedImageIndex1(nextIndex);

    setSelectedImage(
      `${apiurl}/uploads/${progressData1[nextIndex]}`
    );

  }}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "30px",
              background: "rgba(0,0,0,0.5)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              cursor: "pointer",
              zIndex: 10001,
            }}
          >
            ❯
          </button>
        </div>
      )}
     
      {showProgressModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Physical Progress Images</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowProgressModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="row">
                  {progressData?.length > 0 ? (
                    progressData.map((item, index) => (
                      <div className="col-md-4 mb-3" key={index}>
                        <div
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: "10px",
                            padding: "10px",
                            background: "#fff",
                          }}
                        >
                          <img
                            src={`${apiurl}/UploadProgressDocsImages/${item?.image}`}
                            alt="Document"
                            style={{
                              width: "120px",
                              cursor: "pointer",
                              maxHeight: "250px",
                              objectFit: "contain",
                            }}
                              onClick={() => {
                              // setSelectedImageIndex(index);
                              setSelectedImageIndex1(index);
                              setSelectedImage1(
                                `${apiurl}/UploadProgressDocsImages/${item.image}`,
                              );
                              setShowImageModal(true);
                            }}
                          />
                          <div
                            style={{
                              marginTop: "10px",
                              fontSize: "14px",
                              lineHeight: "1.7",
                            }}
                          >
                            <div>
                              📍 <strong>Latitude:</strong>{" "}
                              {item.location?.latitude || "-"}
                            </div>

                            <div>
                              📍 <strong>Longitude:</strong>{" "}
                              {item.location?.longitude || "-"}
                            </div>

                            <div>
                              📅 <strong>Date:</strong>{" "}
                              {item.location?.date || "-"}
                            </div>

                            <div>
                              🕒 <strong>Time:</strong>{" "}
                              {item.location?.time || "-"}
                            </div>

                            <div>
                              ⛰️ <strong>Elevation:</strong>{" "}
                              {item.location?.elevation || "-"} m
                            </div>

                            <div>
                              🎯 <strong>Accuracy:</strong>{" "}
                              {item.location?.accuracy || "-"} m
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No Images Found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showImageModal && (
        <div
          //  onClick={() => setShowImageModal(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();

              const prevIndex =
                (selectedImageIndex - 1 + progressData.length) %
                progressData.length;

              setSelectedImageIndex(prevIndex);
            }}
            style={{
              position: "absolute",
              left: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "30px",
              background: "rgba(0,0,0,0.5)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "45px",
              height: "45px",
              cursor: "pointer",
            }}
          >
            ❮
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              setShowImageModal(false);
            }}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              fontSize: "30px",
              color: "#fff",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              zIndex: 10001,
            }}
          >
            ×
          </button>
          <img
            src={`${apiurl}/UploadProgressDocsImages/${progressData[selectedImageIndex]?.image}`}
            alt="Preview"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: "20px",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
              background: "rgba(0,0,0,0.5)",
              padding: "6px 12px",
              borderRadius: "20px",
            }}
          >
            {selectedImageIndex + 1} / {progressData.length}
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();

              const nextIndex = (selectedImageIndex + 1) % progressData.length;

              setSelectedImageIndex(nextIndex);
            }}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "30px",
              background: "rgba(0,0,0,0.5)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              cursor: "pointer",
              zIndex: 10001,
            }}
          >
            ❯
          </button>
        </div>
      )}
    </>
  );
};

export default ProgressReportInwardsList;
